<template>
	<div class="main" v-if="info.hasOwnProperty('id')" v-wechat-title="region.re_name+('-皖云游-'+info.type_name)+'-'+ info.DicName">
		<TravelTop :info="info" :region="region" :isJudgeGrade="true" />
		<TravelAbout v-if="simages.hasOwnProperty(1)" :simages="simages[1]" :summary="info.Summary" />
		<TravelAudio :audios="audios" />
		<div class="container">
			<div class="panel panel-default">
				<div class="panel-heading">
					<div class="category">
						<a class="category-top">基本资料</a>
						<a class="category-bottom">Basic data</a>
					</div>
				</div>
				<div class="panel-body" style="padding:0px;">
					<div class="container">
						<table class="table">
		                    <thead>
		                        <tr>
		                            <th width="18%"></th>
		                            <th></th>
		                        </tr>
		                    </thead>
		                    <tbody>
		                        <tr><td class="blue"><p>中文名称</p></td><td>{{info.DicName}}</td></tr>
		                        <tr><td class="blue"><p>评定等级</p></td><td>{{info.JudgeGrade?info.JudgeGrade:'暂无'}}</td></tr>
		                        <tr><td class="blue"><p>评定时间</p></td><td>{{info.JudgeTime?info.JudgeTime:'暂无'}}</td></tr>
		                        <tr><td class="blue"><p>所获荣誉</p></td><td>{{info.Honour?info.Honour:'暂无'}}</td></tr>
		                        <tr><td class="blue"><p>行政面积</p></td><td>{{info.Area?info.Area:'暂无'}}</td></tr>
		                        <tr><td class="blue"><p>服务电话</p></td><td><a :href="info.Telphone?'tel:'+info.Telphone:'#'">{{info.Telphone?info.Telphone:'暂无'}}</a> </td></tr>
		                        <tr><td class="blue"><p>重点景点</p></td><td>{{info.MainScenic?info.MainScenic:'暂无'}}</td></tr>
		                        <tr><td class="blue"><p>附近景区</p></td><td>{{info.NearbyScenic?info.NearbyScenic:'暂无'}}</td></tr>

		                        <tr>
									<td class="blue"><p>行政区划</p></td>
									<td v-if="info.city && info.district">安徽省-{{info.city.RegionName}}-{{info.district.RegionName}}{{info.town?'-'+info.town.RegionName:''}}</td>
									<td v-else>暂无</td>
								</tr>
		                        <tr><td class="blue"><p>旅游旺季</p></td><td>{{info.BoomSeason?info.BoomSeason:'暂无'}}</td></tr>
		                        <tr><td class="blue"><p>客流承载</p></td><td>{{info.MaxLoad?info.MaxLoad:'暂无'}}</td></tr>
		                        <tr><td class="blue"><p>最近机场</p></td><td>{{info.Airfield?info.Airfield:'暂无'}}</td></tr>
		                        <tr><td class="blue"><p>最近铁路</p></td><td>{{info.Railroad?info.Railroad:'暂无'}}</td></tr>
		                        <tr><td class="blue"><p>最近高速</p></td><td>{{info.HVRoad?info.HVRoad:'暂无'}}</td></tr>
		                        <tr><td class="blue"><p>美食推荐</p></td><td>{{info.Cate?info.Cate:'暂无'}}</td></tr>
		                        <tr><td class="blue"><p>特产推荐</p></td><td>{{info.SpecialGoods?info.SpecialGoods:'暂无'}}</td></tr>
		                        <tr style="height:20px;"><td></td><td></td></tr>

		                    </tbody>

		                </table>
						
					</div>
				</div>
			</div>
		</div>
		<!-- 天气预报 -->
		<WeatherForecast :list="WeatherForecastList" />
		<TravelMap :info="info" :center="center" :region="region" />
		<!--平面导览-->
		<TravelImage v-if="simages.hasOwnProperty(2)" :simages="simages[2]" />

		<TravelVideo :videos="videos" />

		<TravelScenicmianspots :scenicmianspots="scenicmianspots" name="主要景点" enname="Main scenic spot" />
		<TravelDetail v-if="traffic" name="交通指引" enname="Traffic guide" :detail="traffic.Detail" />
		<TravelDetail name="游玩线路" enname="Tourist route" :detail="info.TouristRoute" />
		<TravelDetail name="特色美食" enname="Delicious food" :detail="info.Foods" />
		<TravelDetail name="消费指南" enname="Consumer guide" :detail="info.ConsumerGuide" />
		<TravelDetail name="旅游商品" enname="Tourism commodity" :detail="info.Commodities" />
		<TravelDetail name="酒店民宿" enname="Hotel&Homestay" :detail="info.Hotels" />
		<TravelDetail name="周边餐饮" enname="Periphery restaurant" :detail="info.Restaurants" />
		<TravelLocalcelebrity :list="localcelebrities" />
		<TravelDetail name="文化作品" enname="Celebrity" :detail="info.Culture" />
		<TravelDetail name="安全提示" enname="Security Information" :detail="info.Security" />
		
		
		
		<Scolllist></Scolllist>
		<!-- 相关词条 -->
		<TravelRelevant :dicrelevants="dicrelevants"/>
		<TravelPingjia :list="pingjia_list" :total="pingjia_total" :info="info" />

		<TravelFooter :info="info" :region="region" />
	</div>
</template>
<script>

import $ from "jquery";
import { travelInfo,areaweather } from '@/api/travel'
import TravelDetail from '@/components/travel/detail'
import TravelRelevant from '@/components/travel/relevant'
import TravelScenicmianspots from '@/components/travel/scenicmianspots'
import TravelVideo from '@/components/travel/video'
import TravelImage from '@/components/travel/image'
import TravelMap from '@/components/travel/map'
import TravelAbout from '@/components/travel/about'
import TravelTop from '@/components/travel/top'
import TravelFooter from '@/components/travel/footer'
import TravelAudio from '@/components/travel/audio'
import TravelLocalcelebrity from '@/components/travel/localcelebrity'
import TravelPingjia from '@/components/travel/pingjia'
import Scolllist from "@/components/Scolllist";
import WeatherForecast from '@/components/travel/weatherForecast'
export default {
    data() {
        return {
            info: this.$store.state.acc,
            user: this.$store.state.user,
            center: { lng: 0, lat: 0 },
            info: {},
            region: {},
            simages: {},
            scenicmianspots: [],
            traffic: {},
            dicrelevants: [],
            videos:[],
            audios:[],
            localcelebrities: [],
            pingjia_list: [],
            pingjia_total: 0,
			WeatherForecastList:[]
        }
    },
    components: {
			TravelMap,
			TravelDetail,
			TravelRelevant,
			TravelScenicmianspots,
			TravelVideo,
			TravelImage,
			TravelAbout,
			TravelTop,
			TravelFooter,
			TravelAudio,
			TravelLocalcelebrity,
			TravelPingjia,
			Scolllist,
			WeatherForecast
		},
    created(e) {
    	this.getInfo()
    },
    methods: {
		//天气预报
		weatherForecast(){
			areaweather({
				Latitude: this.info.Latitude,
				Longitude: this.info.Longitude,
			}).then(res=>{
				// console.log(res);
				res.weadata.forEach(v=>{
					this.WeatherForecastList.push(v)
				})
			})
		},
    	getInfo (){
    		this.$toast.loading({
		      message: '加载中...',
		      forbidClick: false,
		      loadingType: 'spinner',
		      duration: 10000
		    });
    		travelInfo({type: 'Village', id: this.$route.params.id}).then(res=> {
    	this.$toast.clear()
          this.info = res.info
		//   console.log(res.info);
          this.region = res.Region
          this.$store.commit('SET_RGION', this.region)
          this.simages = res.Images
          this.traffic = res.traffic
          this.audios = res.audios
          this.videos = res.videos
          this.localcelebrities = res.localcelebrities
          for (let i in res.scenicmianspots) {
          	res.scenicmianspots[i]['text'] = res.scenicmianspots[i]['SpotName']
          }
          this.scenicmianspots = res.scenicmianspots
          this.dicrelevants = res.dicrelevants
          this.pingjia_list = res.pingjia_list
          this.pingjia_total = res.pingjia_total
		this.weatherForecast()
    		})
    	},
    	
    }
};
</script>
<style>
	body{
		height: auto;
	}
</style>